import * as React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { ExareStatus } from '@websky/graphql';
import { useTheme } from '../../../../../theme';
import { useRefundSummary } from '../../../../../RefundSummary';
import RefundSummary from '../../../../../RefundSummary/components/RefundSummary';
import Notice from '../../../../../RefundSummary/components/Notice/Notice';
import { getOrder, getFlight, getTravellers, getSelectedVskInsurancesByType, getIsExchangeAutoMode, getIsShowRefundNasServices } from '../../../../../Checkout/store/order/selectors';
import AirportServices from '../../../../../Modules/Exchange/components/Exchange/AirportServices/AirportServices';
import { getRefundServicesParams, getInitialFormValues, getExchangePrices } from '@entities/exchange';
import { useLayoutMode } from '@shared/lib/layout-mode';
import { useAutoCreateExchangeOrder } from '@features/exchange/auto-create-exchange-order';
import { useAutoReplaceExchangePrices } from '@features/exchange/auto-replace-exchange-prices';
import { ClearExchangeVariantsButton } from '@features/exchange/clear-exchange-variants';
import { CreateExchangeForm } from '@features/exchange/create-exchange';
import { useRouter } from '@shared/lib/router';
import { ContentWithSelectedFlights } from '../ContentWithSelectedFlights';
import { Receipt } from '../Receipt';
const ExchangeRequest = ({ className, returnToOrder, reloadOrder }) => {
    const layoutMode = useLayoutMode();
    const { t } = useTranslation('Exchange');
    const { Request: theme } = useTheme('Widgets').Exchange;
    const order = useSelector(getOrder);
    const flight = useSelector(getFlight);
    const travellers = useSelector(getTravellers);
    const selectedVskInsurances = useSelector(getSelectedVskInsurancesByType);
    const isShowRefundNasServices = useSelector(getIsShowRefundNasServices);
    const isAutoMode = useSelector(getIsExchangeAutoMode);
    const exchangePrices = useSelector(getExchangePrices);
    const refundServicesParams = useSelector(getRefundServicesParams);
    const initialRequestFormValues = useSelector(getInitialFormValues);
    useAutoCreateExchangeOrder();
    useAutoReplaceExchangePrices();
    const router = useRouter();
    const { gdsServicesRefund, loading: refundServicesLoading } = useRefundSummary(refundServicesParams);
    const onGoToFlights = () => {
        router.navigate('/exchange/flights');
    };
    const onSuccessCreateExchange = (order) => {
        if (order.status !== ExareStatus.AwaitingPayment) {
            return;
        }
        setTimeout(() => router.navigate('/exchange/payment'));
    };
    return (React.createElement(ContentWithSelectedFlights, { className: cn(theme.request, className), controls: React.createElement(ClearExchangeVariantsButton, { label: t('ExchangeRequest.ClearExchangeVariants'), onClick: onGoToFlights }) },
        React.createElement(Receipt, { className: theme.receipt, prices: [
                { label: t('ExchangeReceipt.TicketPrice'), price: exchangePrices.ticket },
                { label: t('ExchangeReceipt.PenaltyPrice'), price: exchangePrices.charge }
            ], totalPrice: exchangePrices.total }),
        gdsServicesRefund && (React.createElement(RefundSummary, { flight: flight, travellers: travellers, gdsServicesRefund: gdsServicesRefund, insurancesRefund: selectedVskInsurances, mode: layoutMode, notification: selectedVskInsurances.length > 0 && (React.createElement(Notice, { className: theme.notification, type: "notice", header: t('Note'), text: t('When the exchange is performed, VSK insurance policies will be canceled') })), isLoading: refundServicesLoading })),
        React.createElement("div", { className: theme.notifications },
            !isAutoMode && (React.createElement(Notice, { className: theme.notification, type: "notice", header: t('Note'), text: t('The possibility and cost of changes will be calculated by the operator after sending the application. The answer will be sent to your E-mail and is also available on the order page.') })),
            React.createElement(Notice, { className: theme.notification, type: "reject", header: t('Exchange restrictions'), text: t('After submitting the request, the seats you have selected will be canceled.') })),
        isShowRefundNasServices ? (React.createElement(AirportServices, { onCancel: returnToOrder, reloadOrder: reloadOrder })) : (React.createElement(CreateExchangeForm, { initialValues: initialRequestFormValues, order: order, isRequiredComment: !isAutoMode, onSuccess: onSuccessCreateExchange }))));
};
export default ExchangeRequest;
